import { render, staticRenderFns } from "./BarangayView.vue?vue&type=template&id=dd50c154"
import script from "./BarangayView.vue?vue&type=script&lang=js"
export * from "./BarangayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports